export enum ImageDataReturnType {
  Base64String,
  Blob,
}